"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _pieLegend = _interopRequireDefault(require("./pieLegend.js"));
var _recharts = require("recharts");
var _styledComponent = require("./styledComponent.js");
var _jsxRuntime = require("react/jsx-runtime");
var _CartesianGrid;
const PieChartComponent = props => {
  const {
    width = 300,
    height = 200,
    data,
    chartDataKey,
    //Based on this data, graphs will appear.  Usually an object's property
    margin = {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    },
    innerRadius = 100,
    tooltipStatus = true,
    grid = false,
    label = '',
    subLabel = '',
    customTooltip,
    showPieLegend = false
  } = props;
  const labelDataContent = labelProps => {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("text", {
      offset: labelProps.offset,
      x: labelProps.viewBox.cx,
      y: labelProps.viewBox.cy,
      textAnchor: "middle",
      children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)("tspan", {
        x: labelProps.viewBox.cx,
        className: "mun-pie-chart-label",
        dy: '0em',
        children: label
      }), subLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)("tspan", {
        x: labelProps.viewBox.cx,
        className: "mun-pie-chart-sub-label",
        dy: '1em',
        children: subLabel
      })]
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styledComponent.StyledPieChartContainer, {
    width: width,
    height: height,
    children: [showPieLegend && /*#__PURE__*/(0, _jsxRuntime.jsx)(_pieLegend.default, {
      data: data,
      height: Number(height),
      chartDataKey: chartDataKey
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.PieChart, {
        margin: margin,
        children: [grid && (_CartesianGrid || (_CartesianGrid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
          strokeDasharray: "1"
        }))), tooltipStatus && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Tooltip, {
          content: customTooltip
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.Pie, {
          className: "mun-squareselector",
          dataKey: chartDataKey,
          data: data,
          labelLine: false,
          innerRadius: innerRadius,
          startAngle: 0,
          endAngle: 360,
          children: [data.map((entry, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Cell, {
            fill: entry.color || '#000'
          }, `cell-${index}`)
          //Send a color property in Data object to change each cell color
          ), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Label, {
            content: labelDataContent,
            position: "center"
          })]
        })]
      })
    })]
  });
};
var _default = exports.default = PieChartComponent;
module.exports = exports.default;
module.exports.default = exports.default;